import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/food_noimage.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-76d77204")

_pushScopeId("data-v-76d77204")
const _hoisted_1 = { class: "shoppinglist-searchresult-item" }
const _hoisted_2 = {
  key: 0,
  class: "shoppinglist-searchresult-item-contents-icon"
}
const _hoisted_3 = {
  key: 1,
  class: "shoppinglist-searchresult-item-contents-icon-image",
  src: _imports_0
}
const _hoisted_4 = { class: "shoppinglist-searchresult-item-contents-name" }
const _hoisted_5 = { class: "shoppinglist-searchresult-item-contents-name-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "shoppinglist-searchresult-item-contents",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectItem(...args)))
    }, [
      (_ctx.isNotRaw)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            (_ctx.imageUrl)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  class: "shoppinglist-searchresult-item-contents-icon-image",
                  src: _ctx.imageUrl,
                  onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onImageError(...args)))
                }, null, 40, ["src"]))
              : (_openBlock(), _createBlock("img", _hoisted_3))
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.ingredientName), 1)
      ])
    ])
  ]))
})